import { SentryHelper } from 'utils/sentryHelper'
import { WHEEL_PAYOUTS, WheelGameRiskEnum } from './config'
import { WheelPayoutConfig, WheelSegments } from './config/types'

export const flatPayout = (risk: WheelGameRiskEnum, segments: WheelSegments): WheelPayoutConfig[] => {
  const payouts: WheelPayoutConfig[] = WHEEL_PAYOUTS[risk] && WHEEL_PAYOUTS[risk][segments]

  if (!payouts) {
    SentryHelper.captureFeatureClientError({
      feature: 'InhouseGame Wheel',
      error: new Error('Could not found payouts'),
      options: {
        payload: {
          segments,
          risk,
        },
      },
    })

    return null
  }

  const groupOfPayouts: {
    count: number
    payout: number
  }[][] = []

  const totalPayoutByGroup = payouts
    .map((payout) => ({ count: payout.rate * segments, payout: payout.payout }))
    .sort((p1, p2) => (p1.count === p2.count ? p1.payout - p2.payout : p2.count - p1.count))

  const totalRemainderPayoutByGroup = totalPayoutByGroup.map((p) => ({
    ...p,
    count: p.count % payouts.length,
  }))

  const perfectNumberOfItemInGroup = totalPayoutByGroup.map((p) => ({
    ...p,
    count: Math.floor(p.count / payouts.length) + (p.count % payouts.length > 0 ? 1 : 0),
  }))

  for (let index = 0; index < totalPayoutByGroup.length; index++) {
    const item = totalPayoutByGroup.map((p, index) => {
      const perfectNumber = perfectNumberOfItemInGroup[index]
      const remainder = totalRemainderPayoutByGroup[index]
      let count = Math.floor(p.count / payouts.length)

      if (count !== perfectNumber.count && remainder.count > 0) {
        remainder.count--
        count += 1
      }

      return {
        ...p,
        count,
      }
    })

    groupOfPayouts.push(item)
  }

  const result = []
  for (let index = 0; index < groupOfPayouts.length; index++) {
    const items = groupOfPayouts[index]

    for (let _index = 0; _index < items.length; _index++) {
      const item = items[_index]
      const payout = payouts.find((p) => p.payout === item.payout)
      result.push(...Array(item.count).fill(payout))
    }
  }
  return result
}
